import React from "react";
import { FooterButton, FooterButtonGroup } from "../footer";

export const DevToolsButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <FooterButtonGroup>
      <FooterButton tooltip={"DevTools"} onClick={onClick} disabled={false} testid="dev-tools-button">
        <svg width="45px" height="31px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 5.25C2 3.45507 3.45507 2 5.25 2H16.75C18.5449 2 20 3.45507 20 5.25V8.00934C19.4951 7.95675 18.9878 7.99076 18.5 8.10566V7H3.5V16.75C3.5 17.7165 4.2835 18.5 5.25 18.5H13.2347L12.7935 19.2641C12.6577 19.4994 12.5652 19.7477 12.5135 20H5.25C3.45507 20 2 18.5449 2 16.75V5.25ZM5.25 3.5C4.2835 3.5 3.5 4.2835 3.5 5.25V5.5H18.5V5.25C18.5 4.2835 17.7165 3.5 16.75 3.5H5.25Z"
            fill="#212121"
          />
          <path
            d="M19.8565 9C19.6411 8.98005 19.4255 8.9803 19.2123 9C18.1194 9.10098 17.0907 9.71296 16.5002 10.7357C15.7915 11.9632 15.9109 13.4415 16.685 14.5239L13.6595 19.7641C13.6153 19.8407 13.5788 19.9196 13.5499 20C13.3149 20.6516 13.5724 21.3977 14.1933 21.7562C14.8908 22.1589 15.7828 21.9199 16.1855 21.2224L19.2166 15.9724C20.5321 16.0903 21.8586 15.4548 22.5624 14.2357C23.3244 12.916 23.1291 11.3063 22.1921 10.2105L20.5417 13.0691C20.2195 13.6271 19.506 13.8183 18.948 13.4961C18.39 13.1739 18.1988 12.4604 18.521 11.9024L20.1714 9.04377C20.0667 9.0243 19.9616 9.00974 19.8565 9Z"
            fill="#212121"
          />
          <path
            d="M15.1652 13.5745C14.9952 12.8933 14.9834 12.1718 15.1463 11.4698L12.8579 9.17831C12.6628 8.98291 12.3462 8.98269 12.1508 9.17782C11.9554 9.37295 11.9552 9.68953 12.1503 9.88493L14.7934 12.5316L12.1503 15.1783C11.9552 15.3737 11.9554 15.6903 12.1508 15.8854C12.3462 16.0805 12.6628 16.0803 12.8579 15.8849L15.1652 13.5745Z"
            fill="#212121"
          />
          <path
            d="M9.85672 9.88537C10.0521 9.69021 10.0523 9.37363 9.85711 9.17826C9.66196 8.98289 9.34538 8.98271 9.15001 9.17787L6.14664 12.1779C6.05275 12.2717 6 12.3989 6 12.5316C6 12.6643 6.05276 12.7916 6.14665 12.8854L9.15001 15.8854C9.34538 16.0805 9.66196 16.0803 9.85711 15.885C10.0523 15.6896 10.0521 15.373 9.85672 15.1779L7.2075 12.5316L9.85672 9.88537Z"
            fill="#212121"
          />
        </svg>
      </FooterButton>
    </FooterButtonGroup>
  );
};
